import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { AdminSection } from '../../models/app.models';

import { AdminOverviewComponent } from './sections/admin-overview/admin-overview.component';
import { AdminHomeComponent } from './sections/admin-home/admin-home.component';
import { AdminAboutComponent } from './sections/admin-about/admin-about.component';
import { AdminYoutubeComponent } from './sections/admin-youtube/admin-youtube.component';
import { AdminLocationsComponent } from './sections/admin-locations/admin-locations.component';
import { AdminCommunityComponent } from './sections/admin-community/admin-community.component';
import { AdminStaffComponent } from './sections/admin-staff/admin-staff.component';
import { AdminWhitelistComponent } from './sections/admin-whitelist/admin-whitelist.component';
import { AdminSettingsComponent } from './sections/admin-settings/admin-settings.component';
import { AdminSocialComponent } from './sections/admin-social/admin-social.component';

@Component({
  selector: 'app-admin-portal',
  standalone: true,
  imports: [
    CommonModule,
    AdminOverviewComponent,
    AdminHomeComponent,
    AdminAboutComponent,
    AdminYoutubeComponent,
    AdminLocationsComponent,
    AdminCommunityComponent,
    AdminStaffComponent,
    AdminWhitelistComponent,
    AdminSettingsComponent,
    AdminSocialComponent
  ],
  templateUrl: './admin-portal.component.html',
  styleUrl: './admin-portal.component.css'
})
export class AdminPortalComponent {

  readonly navigation: Array<{
    id: AdminSection;
    label: string;
    description: string;
  }> = [
    {
      id: 'overview',
      label: 'Overview',
      description: 'Dashboard and quick actions'
    },
    {
      id: 'home',
      label: 'Home Page',
      description: 'Hero content and background'
    },
    {
      id: 'youtube',
      label: 'YouTube Video',
      description: 'Featured website video'
    },
    {
      id: 'locations',
      label: 'Locations',
      description: 'Stores, contact details and hours'
    },
    {
      id: 'social',
      label: 'Social Media',
      description: 'Public social media links'
    },
    {
      id: 'about',
      label: 'About Page',
      description: 'Hero and page sections'
    },
    {
      id: 'community',
      label: 'Community',
      description: 'Posts, images and links'
    },
    {
      id: 'staff',
      label: 'Staff',
      description: 'Team members and photos'
    },
    {
      id: 'whitelist',
      label: 'Portal Resources',
      description: 'Crew and manager links'
    },
    {
      id: 'settings',
      label: 'Settings',
      description: 'Site settings and passwords'
    }
  ];

  activeSection: AdminSection = 'overview';

  constructor() {}

  selectSection(section: AdminSection): void {
    this.activeSection = section;

  }
}